import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {BiSolidEdit} from 'react-icons/bi'
import {PiUserListFill} from 'react-icons/pi'

export const ViewRoleToggle = ({role, onChange}) => {
    const t = useTranslate()
    return (
        <div className="p-1 flex items-center gap-1 background shadow-sm rounded-lg flex-shrink-0">
            {[
                {key: 'admin', icon: <BiSolidEdit size={12}/>, label: t('admin')},
                {key: 'student', icon: <PiUserListFill size={12}/>, label: t('student')},
            ].map(opt => (
                <span
                    key={opt.key}
                    onClick={() => onChange(opt.key)}
                    style={{padding: '3px 10px', height: 28}}
                    className={classNames(
                        "flex items-center gap-1.5 shadow-sm rounded-md font-medium text-xs cursor-pointer transition-all duration-300",
                        role === opt.key
                            ? "bg-primary-100 text-primary-700"
                            : "border border-transparent hover:border-primary-300 background-200 hover:bg-primary-50 text-color-200 hover:text-primary-500"
                    )}>
                    {opt.icon}
                    {opt.label}
                </span>
            ))}
        </div>
    )
}

// Secondary pill-style tab bar — intentionally lighter than the primary card tabs above
// tabs can have isAction: true for action-style tabs (e.g. modal triggers) that don't switch content
export const SecondaryTabBar = ({tabs = [], activeKey, onChange}) => (
    <div className="flex items-center gap-1.5 overflow-x-auto scrollbar-none">
        {tabs.map(tab => (
            <button
                key={tab.key}
                onClick={() => onChange(tab.key)}
                className={classNames(
                    "flex items-center gap-1 px-3 py-1.5 rounded-lg font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0",
                    tab.isAction
                        ? "text-green-600 bg-green-50 hover:bg-green-100 border border-green-200 hover:border-green-300"
                        : activeKey === tab.key
                            ? "bg-blue-100 text-blue-600 border border-blue-500"
                            : "text-color-200 hover:text-blue-500 background border border-color-100 hover:border-blue-400"
                )}>
                {tab.icon}
                {tab.label}
            </button>
        ))}
    </div>
)

// Combined header: secondary tabs left/top, role toggle right/bottom — stacks on mobile.
// role/onRoleChange optional: bỏ trống khi tab đã CHỈ dành riêng 1 vai trò (không cần "xem thử vai
// trò khác" - vd tab Điểm danh giờ chỉ admin mới vào được), tránh hiện toggle vô nghĩa.
export const CourseClassTabHeader = ({tabs, activeKey, onTabChange, role, onRoleChange, showTabs = true}) => (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 mb-1">
        <div className="flex-1 min-w-0 overflow-hidden">
            {showTabs && <SecondaryTabBar tabs={tabs} activeKey={activeKey} onChange={onTabChange}/>}
        </div>
        {role && (
            <div className="flex justify-end flex-shrink-0">
                <ViewRoleToggle role={role} onChange={onRoleChange}/>
            </div>
        )}
    </div>
)
